import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWordGlyph = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      d="M9.5 4.5L6.5 1.5H3C2.72386 1.5 2.5 1.72386 2.5 2V10C2.5 10.2761 2.72386 10.5 3 10.5H9C9.27614 10.5 9.5 10.2761 9.5 10V4.5ZM6.5 1.5V4C6.5 4.27614 6.72386 4.5 7 4.5H9.5M4.5 6.5H6M4.5 8.5H7.75"
      stroke="#fff"
      strokeLinecap="round"
    />
  </svg>
);
export default SvgWordGlyph;
